import React, {useMemo} from 'react';
import {useTranslation} from 'react-i18next';
import {Form, Input} from 'antd';
import {validation} from '../../../../../utils/validation';

const {Item} = Form;

const VatVendorFormItems = () => {
  const [t] = useTranslation(['main', 'vendors']);

  const validationRules = useMemo(() => ({
    vat: validation.vat(t, true),
  }), [t]);

  const trans = (key) => t(`vendors:${key}`);

  const formT = (key) => trans(`modal.addVendor.${key}`);

  const placeholder = (key) => formT(`placeholder.${key}`);

  return (
    <Item
      label={t('vatNumber')}
      name='vat'
      rules={validationRules.vat}
      required
    >
      <Input
        maxLength={15}
        placeholder={placeholder('vat')}
        size='large'
      />
    </Item>
  );
}

export default VatVendorFormItems;
